import { map } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DataLogin } from './autenticacion.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;
@Injectable({
  providedIn: 'root'
})
export class HeaderInfoService {

  constructor(private _http: HttpClient) { }

  public menuOculto = new BehaviorSubject(false);
  public soloBotonMenu = new BehaviorSubject(false);
  
  public tituloPagina = new BehaviorSubject('Lugares');
  public conjunto = new BehaviorSubject('');
  public tituloTarjeta = new BehaviorSubject('¡Bienvenido al perfil!');
  public textoTarjeta = new BehaviorSubject('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.');
  public imagenTarjeta = new BehaviorSubject('./../../../../assets/header/pagina-principal-lugares.svg')
  public imagenUnidad = new BehaviorSubject('https://illustoon.com/photo/5414.png')
  public colorCompania = new BehaviorSubject('#c5e345'); // Color por defecto

  public cambiarTituloPagina(nuevoTituloPagina: string): void {
    this.tituloPagina.next(nuevoTituloPagina);
  }

  public cambiarConjunto(nuevoConjunto: string): void {
    this.conjunto.next(nuevoConjunto);
  }

  public cambiarTituloTarjeta(nuevoTituloTarjeta: string): void {
    this.tituloTarjeta.next(nuevoTituloTarjeta);
  }

  public cambiarTextoTarjeta(nuevoTextoTarjeta: string): void {
    this.textoTarjeta.next(nuevoTextoTarjeta);
  }

  public cambiarImagenTarjeta(nuevaImagenTarjeta: string): void {
    this.imagenTarjeta.next(nuevaImagenTarjeta);
  }
  
  public cambiarImagenUnidad(nuevaImagenUnidad: string): void {
    this.imagenUnidad.next(nuevaImagenUnidad);
  }

  public toggleMenu(): void {
    this.menuOculto.next(!this.menuOculto.value);
  }

  public dejarSoloBotonMenu(nuevoValor: boolean): void {
    this.soloBotonMenu.next(nuevoValor);
  }

  public applyProfileTheme(style: any): void {
    const root = document.documentElement;
  
    /* 🎯 Colores principales */
    root.style.setProperty('--color-primario', style.primary_color);
    root.style.setProperty('--fondo-primario-boton', style.primary_color);
    root.style.setProperty('--color-titulo-descripcion', style.primary_color);
    root.style.setProperty('--hora-calendario', style.primary_color);
    root.style.setProperty('--color-numero-dia-actual', style.primary_color);
    root.style.setProperty('--color-opcion-activa-paginador', style.primary_color);
    root.style.setProperty('--color-spinner', style.primary_color);
  
    /* 🎯 Fondos */
    // root.style.setProperty('--fondo-input', style.tertiary_color);
    root.style.setProperty('--fondo-input', '#ededed');
    root.style.setProperty('--fondo-secundario-boton', style.tertiary_color);
    root.style.setProperty('--color-header-calendario', style.tertiary_color);
  
    /* 🎯 Textos */
    // root.style.setProperty('--color-letra', style.primary_text_color);
    root.style.setProperty('--color-letra', style.secondary_text_color);
    root.style.setProperty('--color-campo', style.secondary_text_color);
    root.style.setProperty('--color-label', style.secondary_text_color);
    root.style.setProperty('--texto-secundario-boton', style.secondary_text_color);
  
    /* 🎯 Placeholders y separadores */
    root.style.setProperty('--color-placeholder', style.secondary_text_color);
    root.style.setProperty('--color-separador', style.secondary_text_color);
  
    /* 🎯 Estados */
    root.style.setProperty('--success', style.success_color);
    root.style.setProperty('--warning', style.warning_color);
    root.style.setProperty('--error', style.error_color);
  
    /* 🎯 Otros */
    root.style.setProperty('--color-flecha', style.secondary_text_color);
    root.style.setProperty('--evento-calendario', style.success_color);
  
    /* 🎯 Fondo general (opcional) */
    root.style.setProperty('--background-app', style.background_color);
  
    /* 🔤 Tipografías */
    root.style.setProperty('--primary-font', style.primary_font_family);
    root.style.setProperty('--secondary-font', style.secondary_font_family);
  }
  
  
  public cambiarColorCompania(nuevoColor: string): void {

    if (!nuevoColor) {
      nuevoColor = '#96c239'; // Color por defecto (mismo que --color-primario)
    }
    
    // Asegurar que tenga el símbolo #
    if (!nuevoColor.startsWith('#')) {
      nuevoColor = '#' + nuevoColor;
    }
    
    this.colorCompania.next(nuevoColor);
    
    // Actualizar la variable CSS --color-primario en el elemento raíz
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty('--color-primario', nuevoColor);
    }
  }

  traerDatosPerfil() {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `https://as-ws-zyon-test-keycloak.azurewebsites.net/api/v1/users/profileweb/${loginData.user_id}`;

    const headers = new HttpHeaders({
      cli: 'PAdmon',
    });
    
    return this._http.get(requestUrl, { headers })
      .pipe(
      map((res: any) => {
        this.cambiarConjunto(res.data.company.name);
        this.cambiarImagenUnidad(res.data.company.logo);
        this.cambiarColorCompania(res.data.company.color);
        this.cambiarImagenTarjeta(res.data.company.cover);
        if(res.data.style) this.applyProfileTheme(res.data.style); 
        return res;
      })
      );
  }
}

export interface DataUnidad {
  data_unidad: UnidadResidencial;
}

export interface UnidadResidencial {
  id: number;
  business_name: string;
  name: string;
  address: string;
  phone: string;
}
